// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PoweroffOutlinedSvg from "@ant-design/icons-svg/es/asn/PoweroffOutlined";
import AntdIcon from '../components/AntdIcon';

var PoweroffOutlined = function PoweroffOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: PoweroffOutlinedSvg
  }));
};

PoweroffOutlined.displayName = 'PoweroffOutlined';
export default React.forwardRef(PoweroffOutlined);